import { StyleSheet, Platform, Dimensions } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const screenHeight = Dimensions.get('window').height;

export default StyleSheet.create({
  quickActionMenuHeaderStyle: {
    marginTop: 16,
    marginHorizontal: 0,
  },
  mainText: theme => ({
    fontSize: 25,
    lineHeight: 31.2,
    marginTop: 17,
    fontFamily: Fonts.type.VodafoneLt,
    color: theme.colors.headerTitleColor,
    marginBottom: 32.6,
  }),
  subText: theme => ({
    fontSize: 14.6,
    lineHeight: 18.7,
    marginTop: 19.8,
    marginBottom: 31.9,
    color: theme.colors.headerTitleColor,
  }),
  primaryButton: {
    marginBottom: 16.4,
  },
  scrollViewStyle: {
    maxHeight: screenHeight * 0.5,
  },
  scrollViewBorder: theme => ({
    borderTopWidth: 1,
    borderTopColor: theme.colors.divider,
  }),
  scrollViewContent: {
    paddingRight: 8,
  },
  modalIconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 53,
  },
  iconContainer: {
    height: 125,
    width: 125,
  },
  modalMessage: theme => ({
    textAlign: 'center',
    marginTop: 33,
    fontSize: Platform.OS === 'ios' ? 25 : 24.4,
    fontWeight: 'bold',
    color: theme.colors.headerTitleColor,
  }),
  modalDescription: theme => ({
    textAlign: 'center',
    marginTop: 20,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    marginBottom: 34.4,
    color: theme.colors.headerTitleColor,
  }),
  modalButton: {
    marginTop: 15,
    width: '100%',
  },
  modalButtonText: {
    fontSize: Platform.OS === 'ios' ? 18.6 : 18,
  },

  loadingLottieView: {
    width: 162,
    height: 162,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingTitle: theme => ({
    fontSize: 16.6,
    fontStyle: 'normal',
    letterSpacing: 0,
    color: theme.colors.loadingTextColor,
    marginTop: 15,
  }),

  loadingContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 150,
    paddingTop: 40,
  },

  giftTitle: {
    marginTop: 33.1,
    marginBottom: 10,
    width: '80%',
    textAlign: 'center',
  },
  txtButton: theme => ({
    color: theme.colors.activeTabColor,
    fontSize: Platform.OS === 'ios' ? 14.6 : 14,
  }),
  iconButton: {
    marginLeft: 5,
    marginTop: -4,
    alignItems: 'center',
  },
});
